import React, { useState } from "react";
import { Icon, useToast } from "@chakra-ui/react";
import { FiEdit3 } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { MdCancel } from "react-icons/md";
import { BsCheckCircle } from "react-icons/bs";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import TdType from "../../Common/Table/TdType";

const ZoneItem = ({
  zone,
  setShowNewZone,
  initialAction = "row",
  addZone,
  updateZone,
  deleteZone,
  isEditable = true,
}) => {
  const [action, setAction] = useState(initialAction);
  const [newZone, setNewZone] = useState(zone);
  const toast = useToast();

  const validateForm = async () => {
    if (!newZone.description || !newZone.name || !newZone.code) {
      toast({
        title: "Se ha producido un error.",
        description: "Verifique todos los campos",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      let zone = { ...newZone };
      switch (action) {
        case "edit":
          await updateZone(zone);
          break;

        case "new":
          await addZone(zone);
          break;
      }
      setShowNewZone(false);
      setAction("row");
    }
  };

  const handleCancel = () => {
    setAction("row");
  };

  const handleChange = (val) => {
    setNewZone({ ...newZone, [val.target.id]: val.target.value });
  };

  const handleEdit = () => {
    setAction("edit");
  };

  const handleSubmit = () => {
    validateForm();
  };

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "edit":
        rowData = [
          {
            item: (
              <TdType
                inputType="input"
                id="code"
                value={newZone.code}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="name"
                value={newZone.name}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="description"
                value={newZone.description}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="deliveryDays"
                value={newZone.deliveryDays}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => handleCancel(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return <ResponsiveRow key={newZone.id} cells={rowData}></ResponsiveRow>;

      case "new":
        rowData = [
          {
            item: (
              <TdType
                inputType="input"
                id="code"
                value={newZone.code}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="name"
                value={newZone.name}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="description"
                value={newZone.description}
                onChange={handleChange}
              />
            ),
          },
          {
            item: (
              <TdType
                inputType="input"
                id="deliveryDays"
                value={newZone.deliveryDays}
                onChange={handleChange}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BsCheckCircle}
                  color="green"
                  onClick={() => handleSubmit()}
                  title={"Aceptar"}
                ></Icon>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={MdCancel}
                  color="red"
                  title={"Cancelar"}
                  onClick={() => setShowNewZone(false)}
                ></Icon>
              </>
            ),
          },
        ];
        return <ResponsiveRow key={newZone.id} cells={rowData}></ResponsiveRow>;

      case "row":
        rowData = [
          {
            item: <TdType text={zone.code} />,
          },
          {
            item: <TdType text={zone.name} />,
          },
          {
            item: <TdType text={zone.description} />,
          },
          {
            item: <TdType text={zone.deliveryDays} />,
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.5em",
              width: "15%",
            },
            item: (
              <>
                {isEditable && (
                  <Icon
                    mx="2"
                    as={FiEdit3}
                    _hover={{ cursor: "pointer" }}
                    onClick={() => handleEdit(zone)}
                    title={"Editar"}
                  ></Icon>
                )}
                <Icon
                  as={FiTrash2}
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  title="Eliminar"
                  onClick={() => deleteZone(zone)}
                />
              </>
            ),
          },
        ];
        return <ResponsiveRow key={zone.id} cells={rowData}></ResponsiveRow>;
    }
  };

  return rowDisplay();
};

export default ZoneItem;
